import { IApplicationState } from '../types/redux';

export const selectSpecialists = (state: IApplicationState) => state.specialists.data?.specialists;
export const selectSpecialistsPage = (state: IApplicationState) => state.specialists.data?.page;
export const selectSpecialistsError = (state: IApplicationState) => state.specialists.errors;
export const selectSpecialistsFetching = (state: IApplicationState) => state.specialists.isFetching;
